import React from "react"
import { Card, CardContent, Typography, Box, useTheme } from "@mui/material"
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Cell,
} from "recharts"

export default function NegotiationsByTagChart({
    title = "Negociações por Tag",
    data,
}) {
    const theme = useTheme()

    // Altura mínima proporcional à quantidade de tags (60px por tag)
    const minChartHeight = Math.max(data.length * 60, 300)

    return (
        <Card sx={{ borderRadius: 1, boxShadow: 1 }}>
            <CardContent>
                <Typography variant="h6" color="text.secondary" gutterBottom>
                    {title}
                </Typography>

                {/* Container com rolagem vertical */}
                <Box sx={{ maxHeight: 300, overflowY: "auto" }}>
                    <Box sx={{ minHeight: minChartHeight }}>
                        <ResponsiveContainer
                            width="100%"
                            height={minChartHeight}
                        >
                            <BarChart
                                data={data}
                                layout="vertical"
                                barSize={30}
                                margin={{
                                    top: 10,
                                    right: 20,
                                    left: 20,
                                    bottom: 10,
                                }}
                            >
                                <XAxis type="number" />
                                <YAxis
                                    type="category"
                                    dataKey="name"
                                    width={150}
                                    interval={0}
                                />
                                <Tooltip
                                    contentStyle={{
                                        backgroundColor:
                                            theme.palette.background.paper,
                                        borderColor: theme.palette.divider,
                                    }}
                                />
                                <Bar
                                    dataKey="value"
                                    radius={[0, 8, 8, 0]}
                                    isAnimationActive
                                >
                                    {data?.map((entry, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={entry.color}
                                        />
                                    ))}
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    )
}
